import { CompanyRoleDto, CreateAdministratorCompanyRoleDto, RowAdministratorCompaniesRolesDto, RowAdministratorCompanyRoleDto, RowFormRoleDto, RowRolesDto, UpdateAdministratorCompanyRoleDto } from "@/dtos";
import { AdministratorCompany, AdministratorCompanyRole, Company, Role } from "@/entities";
import { RoleTypeFilter } from "@/helpers/types";

export const formatRowsFormAdministratorCompanyRoleDto = (
    companies: Company[],
    roles: Role[],
    adminCompanyRoles: RowAdministratorCompanyRoleDto[]
): RowAdministratorCompanyRoleDto[] => {
    return companies.map((x) => {
        const roleDtos = roles.map((r) => {
            const roleDto: RowRolesDto = {
                role_id: r.id,
                name: r.name,
                code: x.id + '-' + r.id,
                min: r.rank_hierarchy.min,
                max: r.rank_hierarchy.max
            }
            return roleDto;
        });

        const objDto: RowAdministratorCompanyRoleDto = {
            company_id: x.id,
            company: x.name,
            is_active: x.is_active,
            roles: roleDtos
        }

        const item = adminCompanyRoles.find((y) => y.company_id === x.id);
        if (item) {
            objDto.roles.map((x) => {
                const role = item.roles.find((u) => u.role_id == x.role_id);
                if (role) {
                    x.hierarchy = role.hierarchy;
                }
            });
        }

        return objDto;
    });
}

export const formatAdministratorCompanyRoleDto = ({
    administrator_company_id, role_id, hierarchy, admin_id, isCreated
}: {
    administrator_company_id: number,
    role_id: number,
    hierarchy: number,
    admin_id: number,
    isCreated: boolean
}): CreateAdministratorCompanyRoleDto | UpdateAdministratorCompanyRoleDto => {

    if (isCreated) {
        const result: CreateAdministratorCompanyRoleDto = {
            administrator_company: { id: administrator_company_id } as AdministratorCompany,
            role: { id: role_id } as Role,
            hierarchy: hierarchy
        }
        return result;
    }
    const result: UpdateAdministratorCompanyRoleDto = {
        administrator_company: { id: administrator_company_id } as AdministratorCompany,
        role: { id: role_id } as Role,
        hierarchy: hierarchy
    }
    return result;
}

export const formatRowAdministratorCompanyRoleDto = (roles: AdministratorCompanyRole[]): RowFormRoleDto[] => {
    return roles.map((x) => {
        const row: RowFormRoleDto = {
            administrator_company_role_id: x.id,
            id: x.role.id,
            name: x.role.name,
            rank_hierarchy: x.role.rank_hierarchy,
            description: x.role.description,
            type_filter: RoleTypeFilter.COMPANY,
            hierarchy: x.hierarchy,
            is_active: x.is_active
        }
        return row;
    });
}

export const formatRowAdministratorCompaniesRolesDtos = (companies: Company[], roles: Role[]): RowAdministratorCompaniesRolesDto[] => {
    return companies.map(c => {
        const items = roles.map(x => {
            const role: CompanyRoleDto = {
                role_id: x.id,
                name: x.name,
                is_active: false,
                hierarchy: undefined,
                rank_hierarchy: x.rank_hierarchy
            }

            return role;
        });

        const row: RowAdministratorCompaniesRolesDto = {
            company_id: c.id,
            name: c.name,
            city: c.city?.name ?? '',
            address: c.address,
            is_active: false,
            items: items
        }

        return row;
    });
}

export const formatRowAdministratorCompaniesRolesDto = (company: Company, roles: Role[]): RowAdministratorCompaniesRolesDto => {
        const items = roles.map(x => {
            const role: CompanyRoleDto = {
                role_id: x.id,
                name: x.name,
                is_active: false,
                hierarchy: undefined,
                rank_hierarchy: x.rank_hierarchy
            }

            return role;
        });

        const row: RowAdministratorCompaniesRolesDto = {
            company_id: company.id,
            name: company.name,
            city: company.city?.name ?? '',
            address: company.address,
            is_active: false,
            items: items
        }


        return row;
      
}